/// <reference path="../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './title';
import { OneRosterService } from './oneroster.service';
import { Alert } from './alert';
import { Registration } from './registration';
import { validateToken } from './account.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AppValidators, controlErrors } from './app.validators';
import { RegistrationRequest } from './registration_request';
import { DropdownOption } from './dropdown_option';
import { RegistrationFind } from './registration_find';
import { trimReturnKey } from './strings';

@Component({
	selector: 'registration-add',
	styles: [`
        .tag {
            margin-right:2px;
            background-color:#9dbd9e;
            border-radius:4px;
            padding:5px;
        }
        .tag-close {
            margin-left:5px;
            cursor: pointer;
        }
    `],
	template: `
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
                <form [formGroup]="form" novalid>
                    <div class="row">
                        <div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">
                            <div class="form-group">
                                <p class="custom-label">One Roster API URL</p>
                                <input type="text" [(ngModel)]="data.oneRosterApiUrl" formControlName="oneRosterApiUrl" class="form-control" placeholder="One Roster API URL" title="One Roster API URL">
                            </div>
							<div class="form-group">
								<p class="custom-label">One Roster API Version</p>
								<select [(ngModel)]="data.oneRosterApiVersion" formControlName="oneRosterApiVersion" class="form-control" title="One Roster API Version">
									<option *ngFor="let orv of oneRosterApiVersions; let i = index" [value]="orv.id">{{orv.title}}</option>
								</select>
							</div>
                            <div class="form-group">
                                <p class="custom-label">OAuth Client ID</p>
                                <input type="text" [(ngModel)]="data.oauthClientId" formControlName="oauthClientId" class="form-control" placeholder="OAuth Client ID" title="OAuth Client ID">
                            </div>
                            <div class="form-group">
                                <p class="custom-label">OAuth Client Secret</p>
                                <input type="text" [(ngModel)]="data.oauthClientSecret" formControlName="oauthClientSecret" class="form-control" placeholder="OAuth Client Secret" title="OAuth Client Secret">
									 </div>
                            <div class="form-group">
                                <p class="custom-label">Authorization</p>
                                <select [(ngModel)]="data.oauthVersion" formControlName="oauthVersion" class="form-control" title="Authorization">
                                    <option *ngFor="let oa of oauthVersions; let i = index" [value]="oa.id">{{oa.title}}</option>
                                </select>
                            </div>
									 <div *ngIf="data.oauthVersion=='oauth-2.0-bearer-token'" class="form-group">
                                <p class="custom-label">OAuth Token Endpoint URL</p>
                                <input type="text" [(ngModel)]="data.oauthTokenEndpoint" formControlName="oauthTokenEndpoint" class="form-control" placeholder="OAuth Token Endpoint URL" title="OAuth Token Endpoint URL">
									 </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
                <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
	    </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
    `,
})

export class RegistrationAddComponent {
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	hasAccess: boolean;
	form: FormGroup;
	// fobj: RegistrationRequest;
	oauthVersions: DropdownOption[];
	oneRosterApiVersions: DropdownOption[];
	idParam: string;
	editMode: boolean;
	data: Registration;
	saveCount: number;

	constructor(
		private router: Router,
		private orvc: OneRosterService,
		fb: FormBuilder,
		private title: AppTitle,
		private activatedRoute: ActivatedRoute
	) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		this.editMode = false;

		this.form = fb.group({
			oneRosterApiUrl: ['', Validators.compose([Validators.required])],
			oauthClientId: ['', Validators.compose([Validators.required])],
			oauthClientSecret: ['', Validators.compose([Validators.required])],
			oauthTokenEndpoint: [''],
			oauthVersion: ['OAuth 1.0 HMAC SHA256'],
			oneRosterApiVersion: ['Version 1.1'],
		});
		this.saveCount = 1;

		this.data = new Registration();
		this.data.oauthVersion = 'oauth-1.0-hmac-sha256';
		this.data.oneRosterApiVersion = '1.1';

		// this.fobj = new RegistrationRequest();
		// this.fobj.oauthVersion = 'oauth-1.0-hmac-sha256';
	}

	ngOnInit() {
		let titleStr = 'Add New';

		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
		this.idParam = this.activatedRoute.snapshot.params['id'];

		if (this.acctNumber != null) {
			this.orvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.orvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}
		this.oauthVersions = [
			{ id: 'oauth-1.0-hmac-sha256', title: 'OAuth 1.0 HMAC SHA256' },
			{ id: 'oauth-1.0-hmac-sha1', title: 'OAuth 1.0 HMAC SHA1' },
			{ id: 'oauth-2.0-bearer-token', title: 'OAuth 2.0 Bearer Token' },
		];

		this.oneRosterApiVersions = [
			{ id: '1.1', title: 'Version 1.1' },
			{ id: '1.2', title: 'Version 1.2' },
		];

		if (this.idParam) {
			this.editMode = true;
			this.loadData();
			titleStr = 'Edit';
		}

		this.title.setTitles({
			title: `${titleStr} Registration`,
			dashboard: `${titleStr} Registration`
		});

		this.title.setBreadcrumbs([
			{ title: 'Registrations ', link: `settings/${this.acctNumber}/registrations` },
			{ title: titleStr, link: `` }
		]);
	}

	loadData() {
		let find = new RegistrationFind();
		find.id = parseInt(this.idParam);
		this.orvc.registrationFindApi(this.acctNumber, find)
			.subscribe((rows: Registration[]) => {
				this.msg.close();
				this.data = rows[0];
				this.form.get('oneRosterApiUrl').setValue(this.data.oneRosterApiUrl);
				this.form.get('oneRosterApiVersion').setValue(this.data.oneRosterApiVersion);
				this.form.get('oauthClientId').setValue(this.data.oauthClientId);
				this.form.get('oauthClientSecret').setValue(this.data.oauthClientSecret);
				this.form.get('oauthVersion').setValue(this.data.oauthVersion);
				if(this.data.oauthVersion === 'oauth-2.0-bearer-token'){
					this.form.get('oauthTokenEndpoint').setValue(this.data.oauthTokenEndpoint);
				}
			}, err => {
				console.log(err);
				if (this.orvc.isErrNotFound(err)) {
					this.msg.warning(this.orvc.getUserError(err));
				} else {
					if (this.orvc.isErrUnauthorized(err)) {
						this.hasAccess = false;
						this.msg.error(this.orvc.getUserErrorDefault(err));
					} else {
						this.msg.error(this.orvc.getUserErrorDefault(err));
					}
				}
			});
	}

	viewToRequest(r: Registration): RegistrationRequest {
		let ret = new RegistrationRequest();
		ret.oneRosterApiVersion = trimReturnKey(r.oneRosterApiVersion);
		ret.syncCrunJob = trimReturnKey(r.syncCrunJob);
		ret.oneRosterApiUrl = trimReturnKey(r.oneRosterApiUrl);
		ret.oauthClientId = trimReturnKey(r.oauthClientId);
		ret.oauthClientSecret = trimReturnKey(r.oauthClientSecret);
		ret.oauthVersion = trimReturnKey(r.oauthVersion);
		if(r.oauthVersion === 'oauth-2.0-bearer-token'){
			ret.oauthTokenEndpoint = trimReturnKey(r.oauthTokenEndpoint);
		}
		return ret;
	}

	save() {
		if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
		}
		this.data.oneRosterApiUrl = this.form.get('oneRosterApiUrl').value;
		this.data.oneRosterApiVersion = this.form.get('oneRosterApiVersion').value;
		this.data.oauthClientId = this.form.get('oauthClientId').value
		this.data.oauthClientSecret = this.form.get('oauthClientSecret').value;
		this.data.oauthVersion = this.form.get('oauthVersion').value;
		if(this.data.oauthVersion === 'oauth-2.0-bearer-token'){
			this.data.oauthTokenEndpoint = this.form.get('oauthTokenEndpoint').value;
		}
		if (this.editMode) {
			this.orvc.registrationUpdateApi(this.acctNumber, this.data.id, this.viewToRequest(this.data))
				.subscribe(res => {
					let saveMessage = this.orvc.getDefaultSaveMessage();
					if (this.saveCount > 1) {
						saveMessage += ` (${this.saveCount})`
					}
					this.saveCount++;
					this.msg.success(saveMessage);
				}, err => {
					console.log(err);
					let e = this.orvc.getUserErrorDefault(err);
					this.msg.error(e);
				});
		} else {
			console.log('REQ', this.viewToRequest(this.data));
			this.orvc.registrationAddApi(this.acctNumber, this.viewToRequest(this.data))
				.subscribe(res => {
					let saveMessage = this.orvc.getDefaultSaveMessage();
					if (this.saveCount > 1) {
						saveMessage += ` (${this.saveCount})`
					}
					this.saveCount++;
					this.msg.success(saveMessage);
				}, err => {
					console.log(err);
					let e = this.orvc.getUserErrorDefault(err);
					this.msg.error(e);
				});
		}
	}


	displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}

	goBack() {
		this.router.navigate([`settings/${this.acctNumber}/registrations`]);
		return;
	}
}
